/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { DriverDtoModel, DriverDtoModelType } from "./DriverDtoModel"
import { DriverDtoModelSelector } from "./DriverDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  driver: DriverDtoModelType;
}

/**
 * DriverAddedDtoBase
 * auto generated base class for the model DriverAddedDtoModel.
 */
export const DriverAddedDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('DriverAddedDto')
  .props({
    __typename: types.optional(types.literal("DriverAddedDto"), "DriverAddedDto"),
    /** Driver that was just added */
    driver: types.union(types.undefined, types.null, MSTGQLRef(types.late((): any => DriverDtoModel))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class DriverAddedDtoModelSelector extends QueryBuilder {
  driver(builder: string | DriverDtoModelSelector | ((selector: DriverDtoModelSelector) => DriverDtoModelSelector) | undefined) { return this.__child(`driver`, DriverDtoModelSelector, builder) }
}
export function selectFromDriverAddedDto() {
  return new DriverAddedDtoModelSelector()
}

export const driverAddedDtoModelPrimitives = selectFromDriverAddedDto()
